import { render, staticRenderFns } from "./SocialShareIcons.vue?vue&type=template&id=26318efc&scoped=true"
import script from "./SocialShareIcons.vue?vue&type=script&lang=js"
export * from "./SocialShareIcons.vue?vue&type=script&lang=js"
import style0 from "./SocialShareIcons.vue?vue&type=style&index=0&id=26318efc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26318efc",
  null
  
)

export default component.exports